module.exports = require("core-js-pure/stable/reflect/construct");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js
// module id = 1367
// module chunks = 25